







































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* components */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import DetailsContent from '@/app/components/FieldDetails/DetailsContent.vue'
import AiAdvicePlans from '@/app/components/FieldDetails/AiAdvicePlans.vue'
import WeatherContent from '@/app/components/FieldDetails/WeatherContent.vue'
import PlantingDensity from '@/app/components/FieldDetails/PlantingDensity.vue'
import GraphSettingModal from '@/app/components/FieldDetails/GraphSettingModal.vue'
import FieldGraph from '@/app/components/FieldDetails/FieldGraph.vue'
import GraphImageModal from '@/app/components/FieldDetails/GraphImageModal.vue'
import GraphMainImageModal from '@/app/components/FieldDetails/GraphMainImageModal.vue'
import StageListModal from '@/app/components/FieldDetails/StageListModal.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* api */
import graphApi from '@/app/model/api/graphApi'
import aiAdvicePlansApi from '@/app/model/api/aiAdvicePlansApi'
import weedGrowthApi from '@/app/model/api/weedGrowthApi'
import sensorApi from '@/app/model/api/sensorApi'
import weatherApi from '@/app/model/api/weatherApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import { harvestStatus } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    DetailsContent,
    AiAdvicePlans,
    WeatherContent,
    PlantingDensity,
    GraphSettingModal,
    FieldGraph,
    GraphImageModal,
    GraphMainImageModal,
    Error409Modal,
    StageListModal,
    ConfirmModal
  }
})
export default class FieldDetails extends Vue {
  /* data */
  private masterData: {[key: string]: any} = {
    prediction_indication: {
      harvest_date: 0,
      harvest_limit_date: 0,
      grade_goal: 0,
      plan_yield: 0
    },
    graph: {},
    growth_stage: [],
    planting_date: 0,
    planting_space_x: null,
    planting_space_y: null,
    planting_density: null
  }
  private graphData: {[key: string]: any} = {
    graph: {},
    harvest_status: 0,
    harvest_status_update_date: '',
    harvest_actual: {
      actual_grade: null,
      actual_harvest: null,
      harvest_actual_date: null,
      harvest_status: null,
      suger_rate: null,
      taste_rank: null
    }
  }
  private comparisonData: {[key: string]: any} = {
    graph: {}
  }
  private weatherData: any = [
    {
      date_time: '',
      humidity: null,
      temp: null,
      weather_code: null,
      weather_name: ''
    },
    {
      date_time: '',
      humidity: null,
      temp: null,
      weather_code: null,
      weather_name: ''
    },
    {
      date_time: '',
      humidity: null,
      temp: null,
      weather_code: null,
      weather_name: ''
    },
    {
      date_time: '',
      humidity: null,
      temp: null,
      weather_code: null,
      weather_name: ''
    }
  ]
  private toastMessage: string = ''
  private plantingLinkData: {[key: string]: any} = {}
  private aiAdvicePlans: {[key: string]: any} = {}
  private gradeList: Array<{[key:string]: string|number}> = []
  private confirmMessage: string = ''
  /* show */
  private isPlanDensityActive: boolean = false
  private showGraphSettingModal: boolean = false
  private renderGraph: boolean = false
  private showGrowthHeight: boolean = false
  private showPrecipitationGraph: boolean = false
  private showLoading: boolean = false
  private showWeatherLoading: boolean = false
  private showPlantingModal: boolean = false
  private showGraphImageModal: boolean = false
  private showGraphMainImageModal: boolean = false
  private gotMasterGraphDataFlag: boolean = false
  private gotGraphDataFlag: boolean = false
  private gotWeedGrowthDataFlag: boolean = false
  private showWeatherErrorFlag: boolean = false
  private weatherErrorMsg: string = ''
  private showAiAdviceLoading: boolean = false
  private showAiAdvicePlans: boolean = false
  private showError409Modal: boolean = false
  private showCheckList: boolean = false
  private showCompletionStatus: boolean = false
  private showStageList: boolean = false
  private showConfirmModal: boolean = false
  private createVarietyGrowthCopyFlag: boolean = false
  private tabResetFlag: boolean = false

  /* グラフ表示項目 */
  private displayYearSeason: string = '-'
  private displayPlantingCultivationMethod: string = '-'
  private displayGraphMaster: string = '-'
  private displayGraphComparison: string = '-'

  /* computed */
  private get growthHeight (): number {
    return this.$store.state.graphToggleState.toggleGrowthHeight
  }
  private get displayYear (): number {
    return this.$store.state.fieldDetailsState.displayYear
  }
  private get img (): boolean {
    return this.$store.state.setFlagState.imgFlag
  }
  private get mainImg (): boolean {
    return this.$store.state.setFlagState.mainImgFlag
  }
  private get graph (): boolean {
    return this.gotGraphDataFlag
  }
  private get masterGraph (): boolean {
    return this.gotMasterGraphDataFlag
  }
  private get weedGrowthGraph (): boolean {
    return this.gotWeedGrowthDataFlag
  }

  @Watch('growthHeight')
  changeGrowthHeight (flag: boolean) {
    this.showGrowthHeight = flag
  }
  @Watch('displayYear')
  changeDisplayYaer (year: string) {
    this.displayYearSeason = year
  }
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange (newVal: any) {
    /* flagリセット */
    this.$store.commit('setFlagState/setGraphDialogFlag', false)
  }
  @Watch('img')
  changeImg (flag: boolean) {
    this.showGraphImageModal = flag
  }
  @Watch('mainImg')
  changeMainImg (flag: boolean) {
    this.showGraphMainImageModal = flag
  }
  @Watch('graph')
  getGraph (flag: boolean) {
    if (flag && this.gotMasterGraphDataFlag && this.gotWeedGrowthDataFlag) {
      /* 表示年度変更 */
      let fieldGraph:any = this.$refs.fieldGraph
      if (fieldGraph !== undefined) {
        fieldGraph.updateDisplayYear()
      }
      this.gotGraphDataFlag = false
      this.gotMasterGraphDataFlag = false
      this.gotWeedGrowthDataFlag = false
    }
  }
  @Watch('masterGraph')
  getMaterGraph (flag: boolean) {
    if (flag && this.gotGraphDataFlag && this.gotWeedGrowthDataFlag) {
      /* 表示年度変更 */
      let fieldGraph:any = this.$refs.fieldGraph
      if (fieldGraph !== undefined) {
        fieldGraph.updateDisplayYear()
      }
      this.gotGraphDataFlag = false
      this.gotMasterGraphDataFlag = false
      this.gotWeedGrowthDataFlag = false
    }
  }
  @Watch('weedGrowthGraph')
  getWeedGrowthGraph (flag: boolean) {
    if (flag && this.gotGraphDataFlag && this.gotMasterGraphDataFlag) {
      /* 表示年度変更 */
      let fieldGraph:any = this.$refs.fieldGraph
      if (fieldGraph !== undefined) {
        fieldGraph.updateDisplayYear()
      }
      this.gotGraphDataFlag = false
      this.gotMasterGraphDataFlag = false
      this.gotWeedGrowthDataFlag = false
    }
  }

  created () {
    // 圃場詳細からの遷移の場合destroyedが効かないので保持データを削除
    this.resetSaveData()

    // 等級の配列を作成
    const constantValue = JSON.parse(Local.getConstantValue()!)
    this.gradeList = constantValue.grades

    const id = this.$route.params.field_id
    let flag = true

    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (settingData !== null && settingData.plantingId !== 0) {
      this.getMasterData(settingData.plantingId, 'master', false)
      this.getGraphData(settingData.plantingId, 'plant', false)

      // 保持している検索データに比較（過去、他圃場）があるか判定
      if (settingData.tab === '2') {
        this.$store.commit('graphToggleState/setShowComparison', true)
        this.addComparisonData({ id: settingData.past, type: 'plant', flag: false })
        this.getComparisonMaster({ id: settingData.past, type: 'master', flag: false })
        this.displayGraphComparison = settingData.pastName
      } else if (settingData.tab === '3') {
        this.$store.commit('graphToggleState/setShowComparison', true)
        this.addComparisonData({ id: settingData.fieldId, type: 'plant', flag: true })
        this.getComparisonMaster({ id: settingData.fieldId, type: 'master', flag: true })
        this.displayGraphComparison = settingData.fieldName
      } else {
        this.$store.commit('graphToggleState/setShowComparison', false)
      }
    } else {
      this.getMasterData(id, 'master', flag)
      this.getGraphData(id, 'plant', flag)
      this.$store.commit('graphToggleState/setShowComparison', false)
    }

    this.getWeatherForecastData(id)
  }

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? this.toLocaleString(value) : '-'
  }

  private isUpdated () {
    this.showLoading = false
  }

  private toggleShowCheckList () {
    this.showCheckList = !this.showCheckList
  }

  private dateToStringYmdHm (date: any) {
    if (date !== null && date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate()) + ' ' + DateClass.toDoubleDigits(updateDate.getHours()) + ':' + DateClass.toDoubleDigits(updateDate.getMinutes())
      return formingDate
    } else {
      return '-'
    }
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number|string) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  private getGradeName (id: number) {
    for (let i in this.gradeList) {
      if (id === this.gradeList[i].grade_id) {
        return this.gradeList[i].grade_name
      }
    }
    return '-'
  }

  private displayHarvestLimit (limitDay: number) {
    const status = this.graphData.harvest_status

    if (status === harvestStatus.CHANCEL ||
        status === harvestStatus.HARVESTE_INSTRUCTIONS ||
        status === harvestStatus.HARVESTED) {
      return ''
    } else if (limitDay === null || limitDay === undefined || limitDay >= 0) {
      return '収穫適期まで'
    } else {
      return '収穫適期から'
    }
  }

  private displayHarvestLimitDay (limitDay: number) {
    const status = this.graphData.harvest_status

    if (status === harvestStatus.CHANCEL) {
      return '収穫中止'
    } else if (status === harvestStatus.HARVESTE_INSTRUCTIONS || status === harvestStatus.HARVESTED) {
      return '収穫済み'
    } else {
      if (limitDay === null || limitDay === undefined) {
        return '-日'
      } else if (limitDay >= 0) {
        return limitDay + '日'
      } else if (limitDay <= -20) {
        return '20日<span style="font-weight: bold;font-size: 14px;">以上超過</span>'
      } else {
        return -(limitDay) + '日<span style="font-weight: bold;font-size: 14px;">超過</span>'
      }
    }
  }

  private jugeConfirmModalMessage (stageName: string) {
    const defultText = '<p class="caution">※作付けの品種生育をコピーして作成します。</p><p class="caution" style="margin: 0;">※不足している目標値はコピー元の値を利用します。</p>'
    if (stageName === '') {
      this.confirmMessage = '<p>実績データがありませんが<br/>よろしいですか？</p>' + defultText
    } else {
      this.confirmMessage = '<p>' + stageName + '以降の実績データがありませんが<br/>よろしいですか？</p>' + defultText
    }

    this.showConfirmModal = true
  }

  /*
   * 画面遷移時にグラフデータを初期化
   */
  destroyed () {
    this.resetSaveData()
  }

  private resetSaveData () {
    this.showGraphSettingModal = false
    /* ローカルストレージ削除 */
    sessionStorage.removeItem('minHarvestTime')
    sessionStorage.removeItem('maxHarvestTime')
    sessionStorage.removeItem('growthStage')
    sessionStorage.removeItem('predictionData')
    sessionStorage.removeItem('masterData')
    sessionStorage.removeItem('defaultGraph')
    sessionStorage.removeItem('graphData')
    sessionStorage.removeItem('comparisonData')
    sessionStorage.removeItem('masterWaterLevelData')
    sessionStorage.removeItem('MasterWaterControls')
    sessionStorage.removeItem('plantingDay')
    sessionStorage.removeItem('HarvestDate')
    sessionStorage.removeItem('harvestTime')

    /* フラグリセット */
    this.$store.commit('setFlagState/setGraphDialogFlag', false)
    this.$store.commit('graphToggleState/setHiddenComparisonData', true)
    this.$store.commit('graphState/setDefaultGraphYear', '')
    this.$store.commit('graphState/setDefaultGraphSeason', '')
    this.$store.commit('setFlagState/setGraphMasterDataFlag', false)
  }

  /* マスターデータ取得 */
  private getMasterData (id: string, type:string, flag: boolean) {
    (async () => {
      const result = await graphApi.getGraphData(id, type, flag)
      if (result.isOk()) {
        Session.setVarietyId(result.getPayload().variety_id)
        Session.setDistrictId(result.getPayload().district_id)
        this.masterData = result.getPayload()
        this.$store.commit('stageUpdateState/setChangeId', 0)

        if (this.masterData.graph_goal === null) {
          let children: any = this.$refs.updateGraphData
          if (children !== null && children !== undefined) {
            children.hiddenGraphItem()
          }

          this.toastMessage = '作付け予測データが作成されていません。'
          this.showPlantingModal = true
        } else if (result.getPayload().growth_stage.length !== 0) {
          Session.setPlantingDay(JSON.stringify(this.masterData.planting_date))
          // ステージ情報
          Session.setGrowthStage(JSON.stringify(this.masterData.growth_stage)!)
          let growthData = this.masterData.growth_stage
          let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
          let stageList = []
          // ステージリスト作成
          for (let i in growthData) {
            let newDate = new Date(plantingDate.getTime() + (growthData[i].elapsed_days * 24 * 60 * 60 * 1000))
            let date = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
            stageList.push({
              stage_date: date,
              growth_step: growthData[i].growth_step,
              growth_stage_name: growthData[i].growth_stage_name
            })
          }
          this.$store.commit('fieldDetailsState/setStageData', stageList)

          Session.setHarvestDate(this.masterData.prediction_indication.harvest_date)
          Session.setPredictionData(JSON.stringify(this.masterData.graph)!)
          Session.setMasterData(JSON.stringify(this.masterData.graph_goal)!)
          Session.setMasterWaterLevelData(JSON.stringify(this.masterData.watering_graph_goal)!)
          Session.setMasterSolarRadationData(JSON.stringify(this.masterData.solar_radation_goal)!)
          Session.setMasterWateringControls(JSON.stringify(this.masterData.watering_controls)!)
          Session.setHarvestTime(JSON.stringify(this.masterData.prediction_indication.harvest_date))
          Session.setHarvestDetails(JSON.stringify(this.masterData.prediction_indication))
          this.plantingLinkData = {
            planting_link: this.masterData.planting_link,
            planting_link_icon: this.masterData.planting_link_icon
          }
          Session.setStemNumberType(String(this.masterData.stem_number_type))
          // AIアドバイスがnullでなければAIアドバイス計画取得
          if (this.masterData.ai_advice_id !== null) {
            this.showAiAdvicePlans = true
            this.showAiAdviceLoading = true
            this.getAiAdvicePlans()
          }

          /* データ追加フラグ */
          this.$store.commit('setFlagState/setGraphMasterDataFlag', true)

          /* 表示年度とシーズン */
          let year = this.masterData.planting_year
          let display = year + '年 ' + this.masterData.planting_season
          this.$store.commit('fieldDetailsState/setDisplayYear', display)
          this.displayYearSeason = display

          /* 表示栽培方法 */
          this.displayPlantingCultivationMethod = this.masterData.planting_cultivation_method_name

          /* 表示目標 */
          // 目標値データがない場合は「-」ある場合は目標名を表示する
          if (Object.keys(this.masterData.graph_goal).length === 0) {
            this.displayGraphMaster = '-'
          } else {
            this.displayGraphMaster = this.masterData.variety_growth_name
          }

          this.$store.commit('stageUpdateState/setDefaultStageData', this.masterData.growth_stage)
        } else {
          Session.setMasterData('{}')
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.gotMasterGraphDataFlag = true
    })()
  }

  private changeShowGraphSettingModal () {
    this.showGraphSettingModal = true
    this.$store.commit('setFlagState/setOpenSettingModalFlag', true)
    // 日程変更モーダルを閉じる
    const fieldGraph:any = this.$refs.fieldGraph
    if (fieldGraph !== undefined) {
      fieldGraph.closeStageUpdateModal()
    }
  }

  private getWeedGrowthData () {
    (async () => {
      const result = await weedGrowthApi.getWeedGrowth(parseInt(this.$route.params.field_id), this.graphData.planting_id)

      if (result.isOk()) {
        Session.setWeedGrowthData(JSON.stringify(result.getPayload()))
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.gotWeedGrowthDataFlag = true
    })()
  }

  /* 実測データ取得 */
  private getGraphData (id: string, type: string, flag: boolean) {
    (async () => {
      this.showLoading = true
      const result = await graphApi.getGraphData(id, type, flag)
      if (result.isOk()) {
        this.graphData = result.getPayload()
        this.getWeedGrowthData()
        Session.setPlantingId(this.graphData.planting_id)
        Session.setImageRecords(JSON.stringify(this.graphData.image_records)!)
        Session.setPointIcons(JSON.stringify(this.graphData.point_icons)!)
        Session.setRiskRecords(JSON.stringify(this.graphData.risk_records)!)
        Session.setHarvestStatusData(this.graphData.harvest_status)
        Session.setHarvestStatusUpdateData(this.graphData.harvest_status_update_date)
        this.$store.commit('setFlagState/setPlantingIdFlag', true)

        if (this.graphData.planting_id === 0) {
          let children: any = this.$refs.updateGraphData
          if (children !== null && children !== undefined) {
            children.hiddenGraphItem()
          }

          this.graphData.harvest_actual = {
            actual_grade: null,
            actual_harvest: null,
            harvest_actual_date: null,
            harvest_status: null,
            suger_rate: null,
            taste_rank: null
          }

          this.toastMessage = '作付け情報がありません。'
          this.showPlantingModal = true
        } else {
          Session.setHarvestStatus(String(this.graphData.harvest_status))
          Session.setHarvestStatusDay(this.graphData.harvest_status_update_date)
          if (result.getPayload().graph !== null) {
            Session.setGraphLastDay(Object.keys(result.getPayload().graph).pop())
            Session.setGraphData(JSON.stringify(this.graphData.graph)!)
          } else {
            Session.setGraphLastDay(Object.keys(result.getPayload().planting_date))
            let plantingDate: any = {}
            // 空のデータを登録
            plantingDate[result.getPayload().planting_date] = {
              elapsed_days: 0,
              ground_temp: null,
              growth_height: null,
              integrated_precipitation_amount: 0,
              integration_temperature: 0,
              ph: null,
              spad: null,
              stem_number: null,
              water_level: null,
              water_temp: null
            }
            Session.setGraphData(JSON.stringify(plantingDate))
          }
          Session.setDefaultGraphData(JSON.stringify(this.graphData.graph)!)

          this.renderGraph = true

          // localStorage変更フラグ更新
          this.$store.commit('setFlagState/setGraphDialogFlag', true)
          this.$store.commit('setFlagState/setSensorDataFlag', true)

          // センサーデータ取得
          this.getSensorData()
        }
        this.$store.commit('setFlagState/setGraphActualDataFlag', true)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.gotGraphDataFlag = true
    })()
  }

  /* AIアドバイス取得 */
  private getAiAdvicePlans () {
    (async () => {
      const result = await aiAdvicePlansApi.getAiAdvicePlans(this.masterData.ai_advice_id)

      if (result.isOk()) {
        this.aiAdvicePlans = result.getPayload()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }

      this.showAiAdviceLoading = false
    })()
  }

  /* センサーデータ取得 */
  private getSensorData () {
    (async () => {
      // localStorageにセンサーデータがなければAPIを叩く
      if (Session.getSensorData(this.graphData.planting_id) === null) {
        const result = await sensorApi.getSensorData(this.graphData.planting_id, 'all')
        let sensorList = []

        if (result.isOk()) {
          // 取得で来たらタイムスタンプを付与してlocalStorageに追加
          sensorList = result.getPayload()
          sensorList.unshift({ timestamp: Date.now() })
          Session.setSensorData(JSON.stringify(sensorList), this.graphData.planting_id)
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        }

        // localstorageフラグ更新
        this.$store.commit('setFlagState/setSensorDataFlag', true)
      }
    })()
  }

  /* 天気予報データ取得 */
  private getWeatherForecastData (id: string) {
    (async () => {
      this.showWeatherLoading = true
      const result = await weatherApi.getWeatherData(id)
      if (result.isOk()) {
        this.weatherData = result.getPayload().weathers
      } else if (result.getPayload().status_code === '500' && result.getPayload().errors[0].code === 'ER002') {
        // M2M取得エラー
        this.showWeatherErrorFlag = true
        this.weatherErrorMsg = '天気情報が取得できませんでした。'
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showWeatherLoading = false
    })()
  }

  /* 日付形式に変換 */
  private toDate (val: number) : string {
    return DateClass.displayData(val)
  }

  private dateToStringYmd (date: any) {
    if (date !== null && date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = parseInt(DateClass.toDoubleDigits(updateDate.getMonth() + 1)) + '月' + parseInt(DateClass.toDoubleDigits(updateDate.getDate())) + '日'
      return formingDate
    } else {
      return '-月-日'
    }
  }

  private disabledGraphSettingBtn: boolean = true

  private getPastData (data: any) {
    // 作付けが1件もない、または、作付けが1件かつ予測データ未作成の場合はグラフ設定ボタンを非活性にする
    if (this.graphData.planting_id === 0 || (data.length === 1 && this.masterData.graph_goal === null)) {
      this.disabledGraphSettingBtn = true
    } else {
      this.disabledGraphSettingBtn = false
    }
  }

  /* グラフ設定で表示変更 ※表示押下時は必ず入る */
  public changeCheckboxes (data: any) {
    this.showLoading = true
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    /* 選択が初期値だった場合 または 比較に選択が無い場合 */
    if (settingData === null || settingData.tab === '1') {
      let fieldGraph:any = this.$refs.fieldGraph
      fieldGraph.displayGraph(data)
    }
  }

  /* 比較に選択がある場合、グラフデータを追加 */
  private addComparisonData (val: any) {
    (async () => {
      this.showLoading = true
      const result = await graphApi.getGraphData(val.id, val.type, val.flag)
      if (result.isOk()) {
        this.comparisonData = result.getPayload()
        Session.setComparisonData(JSON.stringify(this.comparisonData.graph)!)
        this.$store.commit('setFlagState/setComparisonPlantFlag', true)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  /* 比較に選択がある場合、マスターデータを取得 */
  private getComparisonMaster (val: any) {
    (async () => {
      const result = await graphApi.getGraphData(val.id, val.type, val.flag)
      if (result.isOk()) {
        this.displayPlantingCultivationMethod = result.getPayload().planting_cultivation_method_name
        Session.setComparisonStageData(JSON.stringify(result.getPayload().growth_stage))
        Session.setComparisonPredictionData(JSON.stringify(result.getPayload().graph)!)
        this.$store.commit('setFlagState/setComparisonMasterFlag', true)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  /* 再取得 */
  private reacquireStageData () {
    this.getMasterData(this.graphData.planting_id, 'master', false)
    this.getGraphData(this.graphData.planting_id, 'plant', false)
  }

  /* グラフ表示項目を表示 */
  private displayGraphItem (val: any) {
    /* 比較(圃場) */
    if (val.field !== '') {
      this.displayGraphComparison = val.field
    } else if (val.past !== '') {
      this.displayGraphComparison = val.past
    } else {
      this.displayGraphComparison = '-'
    }
  }

  /* 表示年に設定年以外を選択した場合、変更 */
  private changeDisplayYear (id: string) : void {
    this.graphData.harvest_actual = {
      actual_grade: null,
      actual_harvest: null,
      harvest_actual_date: null,
      harvest_status: null,
      suger_rate: null,
      taste_rank: null
    }
    this.isPlanDensityActive = false
    this.getGraphData(id, 'plant', false)
    this.getMasterData(id, 'master', false)
  }

  /* グラフ設定モーダルを閉じる */
  private closeGraphSettingModal () {
    this.showGraphSettingModal = false
    const fieldGraph:any = this.$refs.fieldGraph
    fieldGraph.resizeWidth()
  }

  private closePlantingModal () {
    this.showPlantingModal = false
  }

  private stringCut (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 10) {
        return data.substr(0, 9) + '…'
      } else {
        return data
      }
    }
  }

  /* 作業ステータスの判定 */
  private judgmentCompletionStatus (status: number) {
    switch (status) {
      case 1:
        this.showCompletionStatus = true
        return '完成版'

      case 2:
        this.showCompletionStatus = true
        return '暫定版'

      case 3:
        this.showCompletionStatus = true
        return '情報未入手'

      default:
        this.showCompletionStatus = false
        return ''
    }
  }

  /* 作付け情報が無い場合 */
  private showSeasonError () {
    Vue.prototype.$alert.toast({ text: '作付け情報が見つかりませんでした。', type: 1 })
  }

  private showStageListModal (flag: boolean) {
    this.showStageList = flag
  }

  public changeImageModal () {
    this.showGraphImageModal = true
  }

  public closeGraphImageModal () {
    this.showGraphImageModal = false
    this.$store.commit('fieldDetailsState/setImgDate', 0)
  }

  public closeGraphMainImageModal () {
    this.showGraphMainImageModal = false
    this.$store.commit('fieldDetailsState/setImgDate', 0)
  }
}
